import { render, staticRenderFns } from "./WalletsSearch.vue?vue&type=template&id=52bab4e2&"
import script from "./WalletsSearch.vue?vue&type=script&lang=ts&"
export * from "./WalletsSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports